import $ from 'jquery'
import { extractMessageFromAjaxFailure } from './ajax-error'

const debug = require('debug')('pm:templates-push')
debug('loaded')

$(() => {
  const $form = $('.js-templates-push-form')
  const $preview = $form.find('.js-templates-push-preview')
  const $pushButton = $form.find('.js-templates-push')
  const $destServerField = $form.find('.js-dest-server-id')

  const pushButtonDisabled = disabled => $pushButton.prop('disabled', disabled)

  const hasAnythingToPush = () =>
    $preview.find('.js-templates-push-available').data('changes-present')

  const loading = on =>
    on
      ? $preview.addClass('u-is-loading')
      : $preview.removeClass('u-is-loading')

  watchSelectServerChange()
  watchServerLookupChange()

  function watchSelectServerChange() {
    $form.find('.js-templates-push-server').each(function () {
      const $el = $(this)
      const pushPreviewUrl = $el.data('push-preview-url')

      $el.on('change', handleChange)

      handleChange()

      function handleChange() {
        if ($el.val() === '') {
          resetForm()
        } else {
          fetchPushPreview(pushPreviewUrl, $el.val())
        }
      }
    })
  }

  function watchServerLookupChange() {
    $form.find('.js-server-push-lookup').each(function () {
      const $el = $(this)
      const pushPreviewUrl = $el.data('push-preview-url')

      $el.on('autocomplete:selected', function (event, item) {
        $el.data('selected-item', item.name)
        fetchPushPreview(pushPreviewUrl, item.id)
      })

      $el.on('keyup', function () {
        // Disable the form if the current value doesn't match the last selected item.
        if ($el.val() !== $el.data('selected-item')) {
          resetForm()
        }
      })
    })
  }

  function fetchPushPreview(url, serverId) {
    debug('fetching changes', { url, serverId })

    $destServerField.val(serverId)

    loading(true)
    pushButtonDisabled(true)

    $.get(url, $form.serialize())
      .done(function (response) {
        debug('fetched!')
        $preview.html(response)

        if (hasAnythingToPush)
          $preview.find('.js-templates-push-available').showMe()

        pushButtonDisabled(!hasAnythingToPush())
      })
      .fail(function (jqXHR) {
        debug('failed to fetch!', { jqXHR })

        resetForm()

        const message = extractMessageFromAjaxFailure(
          jqXHR,
          'There was a problem grabbing a preview of the changed files. Try selecting the server again.'
        )

        const label = $('<p>').addClass('o-label-danger').text(message)

        $preview.append(label)
      })
      .always(function () {
        loading(false)
      })
  }

  function resetForm() {
    $preview.empty()
    $destServerField.val('')
    pushButtonDisabled(true)
  }
})
